import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Stack,
  Divider,
  Link,
  Chip,
  Box,
  useTheme,
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

const ClinicLink = ({ data = [] }) => {
  const theme = useTheme();

  if (!data?.length) return null;

  return (
    <Card
      elevation={3}
      sx={{
        boxShadow: theme.shadows[1],
        backgroundColor: theme.palette.gery.white,
        mb: 4,
      }}
    >
      <CardContent>
        <Stack spacing={2}>
          <Typography
            variant="h3"
            display="flex"
            alignItems="center"
            sx={{ color: theme.palette.text.primary }}
          >
            <LanguageIcon
              fontSize="small"
              sx={{ mr: 1, color: theme.palette.action.purpleLight }}
            />
            Clinic Links
          </Typography>

          <Divider sx={{ borderColor: theme.palette.gery.lightGray }} />

          {data.map((link, index) => (
            <Box
              key={index}
              p={2}
              borderRadius={2}
              sx={{
                backgroundColor: theme.palette.gery.extraLightGray,
              }}
            >
              <Typography
                variant="small"
                sx={{ color: theme.palette.text.secondary, mb: 0.5 }}
              >
                {link.linkType}
              </Typography>

              <Stack direction="row" alignItems="center" spacing={1}>
                <Link
                  href={link.url?.startsWith('http') ? link.url : `https://${link.url}`}
                  target="_blank"
                  rel="noopener"
                  underline="hover"
                  sx={{
                    fontSize: theme.typography.small.fontSize,
                    fontWeight: theme.typography.small.fontWeight,
                    color: theme.palette.primary.main,
                  }}
                >
                  {link.linkTitle}
                </Link>

                <Chip
                  size="small"
                  label={link.type}
                  color="primary"
                  variant="outlined"
                  sx={{
                    fontSize: '0.75rem',
                    borderColor: theme.palette.primary.main,
                    color: theme.palette.primary.main,
                  }}
                />
              </Stack>
            </Box>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ClinicLink;
